module.exports = __webpack_public_path__ + "img/rebuild_liao_mob1.04a500e9.jpg";